import css from "./popUp.module.css";
import React from "react";

const PopUpSuport = React.forwardRef(({ onClick }, ref) => {
  return (
    <div className={css.suportPopWrap} ref={ref} onClick={onClick}>
      <p className={css.mainPopP}>
        Якщо ви працюєте продавцем-консультантом у книгарні, реєструйтеся на
        сайті як продавець книжок — і отримуйте доступ до конференцій "Скрипти
        продажу книжок "Часу майстрів", "Ефективний продаж книжок", а також
        прямих консультацій із керівниками видавництва.
      </p>
    </div>
  );
});
export default PopUpSuport;
